
  import { defineComponent, PropType } from 'vue';

  import { TBaseInfoItem } from './types';

  export default defineComponent({
    name: 'BaseInfo',
    props: {
      items: {
        type: Array as PropType<TBaseInfoItem[]>,
        required: true,
      },
    },
    methods: {
      getValue(value: string) {
        return value || '-';
      },
    },
  });
